module.exports = __webpack_public_path__ + "img/content1.43222973.jpg";